import { AppEnvironment, overrideWithUserEnvironment } from './environment-util';

declare const injectedUserEnv: Record<string, string | number | boolean> | undefined;

export const environment: AppEnvironment = overrideWithUserEnvironment({
    supportedLanguages: ['en-ca', 'fr-ca'],
    buildTimestamp: `${new Date().getTime()}`,
    local: false,
    production: false,
    api: {
        baseUrl: "https://instruments-stage-api.spark.healthstandards.org",
        services: {
            question: "/v1/question",
            response: "/v1/response",
            launch: "/v1/launch",
            organization: "/v1/organization",
        },
        authToken: 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJyZXNwb25kZW50QGhlYWx0aHN0YW5kYXJkcy5vcmciLCJzY29wZXMiOlsiUk9MRV9SRVNQT05ERU5UIl0sInR5cGUiOiJSRVNQT05ERU5UIiwiYXNzZXNzb3IiOiJ0cnVlIiwiaWF0IjoxNzQ5ODM5NDQwLCJleHAiOjIwNjUxOTk0NDB9.hEIj1HnCQifXlHgY_XGNLznfv1yFusXQ6NbgHUzb-WTGlsTtL3tlOUh9B6HXfwbk2jW58FqBx6q5PDIS5hGmlSxV5oAvTZ4-WEb4S_EZ4WiS90Mwt-Mz33n-zwC2gkugI-SH8YzGL7XK5qRJlSGpgBUd-OshDABKKvG2HMMuMgo1eGxqpiZlp_7jCO1CwEC_2oA9sFUUWLgdASQjT3_aAHGb6pXYGef1_2XRXnjfsEcyWmKLf6AtKcG6RK3_tfzmjHMa3-c1bZNoUzuoVewv5zuVhYRfQ3yy5lBwLfq4Feusss17MRCDmFAJr3vzyg8kOg-rUxN3zA2FjpYgsDXpfg',
    },
    googleAnalytics: {
        enabled: true,
        trackingId: 'G-L1KZDLR717'
    },
    underMaintenance: {
        activated: undefined,
        activationDate: undefined,
        headsup: {
            statement: {
                'en-ca': "Survey Instruments will soon undergo maintenance.",
                'fr-ca': "Les instruments d'enquête feront bientôt l'objet d'une maintenance.",
            },
            enabled: undefined,
        },
    },
}, injectedUserEnv);
